import script from "./TotalOnev2.vue?vue&type=script&setup=true&lang=js"
export * from "./TotalOnev2.vue?vue&type=script&setup=true&lang=js"

import "./TotalOnev2.vue?vue&type=style&index=0&id=22f8e760&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22f8e760"]])

export default __exports__